import { ApiResponseType } from '@/types/sharedTypes';
import { authApiService } from '@/api/authApiService';

export type InternalOrganizationMasterServiceAgreementDetailsResponseType = {
  last_name: string;
  first_name: string;
  middle_name: string;
  organization_name: string;
  confirm_user_email: string;
  consent_check: true;
  date_created: string;
  agreement: {
    id: string;
    agreement_html: string;
    date_version: string;
  };
};

export const getInternalOrganizationMasterServiceAgreementDetailsApi = async (): Promise<
  ApiResponseType<InternalOrganizationMasterServiceAgreementDetailsResponseType>
> => {
  const uri = '/organization/internal/master-service-agreement/confirmation/';

  return authApiService.GET(uri);
};
